module.exports = __webpack_public_path__ + "static/13-50468f1c3a3821a62672932f2e278ec1.jpeg";